<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="名称"
            v-model="district_obj.label"
          />
        </div>
        <div class="col-2">
          <label for="DistrictCd" class="form-label">地区コード</label>
          <input
            type="text"
            class="form-control"
            id="DistrictCd"
            placeholder="地区コード"
            v-model="district_obj.district_cd"
          />
        </div>
        <div class="col-2">
          <label for="RegionCd" class="form-label">地域</label>
          <bs-select
            :options="region_list"
            v-model="district_obj.region_cd"
            :null-option="false"
            id="RegionCd"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-2">
          <label for="PrefCd" class="form-label">都道府県</label>
          <bs-select
            :options="pref_sort"
            v-model="district_obj.pref_cd"
            :null-option="false"
            id="RegionCd"
            :PrefCd="'form-select'"
          ></bs-select>
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="district_obj.sort"
          />
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import config from '../../../const'

export default {
  name: 'AreaRegionDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '地区データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      region_obj: [],
      pref_obj: [],
      district_obj: {}
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadDistrictObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_district/lists',
        params
      )
        .then(async response => {
          console.log('loadDistrictObj', response)
          this.district_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.district_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.district_obj)
      return this.$store
        .dispatch('updateBasic', {
          data: this.district_obj,
          target: 'area_district'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadDistrictObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    pref_sort: function () {
      if (
        !this.district_obj.region_cd ||
        !this.pref_list.find(
          list => list.region_cd == this.district_obj.region_cd
        )
      ) {
        return this.pref_list
      }
      return this.pref_list.filter(list => {
        if (list.region_cd == this.district_obj.region_cd) {
          return true
        }
        return false
      })
    },
    pref_list: function () {
      const lists = [...this.pref_obj]
      return lists
        .map(list => {
          list.key = list.pref_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    region_list: function () {
      const lists = [...this.region_obj]
      return lists
        .map(list => {
          list.key = list.region_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    }
  },

  async created() {
    await this.loadRegionList()
    await this.loadPrefList()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadDistrictObj()
      this.btnLabel = '更新'
    } else {
      this.district_obj = {
        id: 0,
        label: '',
        district_cd: '',
        region_cd: '',
        pref_cd: '',
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = '地区データ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
